(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Update quantity
    function updateCartItem(key, quantity) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (quantity === 0) {
          // Remove row from DOM
          var row = document.querySelector('[data-line-item-key="' + key + '"]');
          if (row) row.remove();

          // Check if cart is empty
          if (cart.item_count === 0) {
            location.reload();
          }
        } else {
          // Update subtotal
          location.reload(); // Simple reload for now
        }
      });
    }

    // Quantity input change
    document.querySelectorAll('.qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        var key = this.dataset.lineItemKey;
        var newQty = parseInt(this.value) || 1;
        if (newQty >= 1) {
          updateCartItem(key, newQty);
        }
      });
    });

    // Remove button
    document.querySelectorAll('.cart-remove-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.lineItemKey;
        updateCartItem(key, 0);
      });
    });

    // Cart note
    var noteTextarea = document.getElementById('cart-note');
    if (noteTextarea) {
      var debounceTimer;
      noteTextarea.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        var note = this.value;
        debounceTimer = setTimeout(function() {
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note })
          });
        }, 500);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Quantity buttons
    var minusBtn = document.querySelector('.qty-minus');
    var plusBtn = document.querySelector('.qty-plus');
    var qtyInput = document.getElementById('quantity');

    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal > 1) {
          qtyInput.value = currentVal - 1;
        }
      });

      plusBtn.addEventListener('click', function() {
        var currentVal = parseInt(qtyInput.value) || 1;
        qtyInput.value = currentVal + 1;
      });
    }

    // Variant selector - update price display
    var variantSelect = document.getElementById('variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        // Could update price display here if needed
      });
    }

    // Add to cart form submission
    var productForm = document.getElementById('product-form');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();

        var formData = new FormData(this);
        var submitBtn = this.querySelector('.add-to-cart-btn');
        var originalText = submitBtn.textContent;

        submitBtn.textContent = 'Se adauga...';
        submitBtn.disabled = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(item) {
          submitBtn.textContent = 'Adaugat!';

          // Update cart count
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEl = document.querySelector('.cart-count');
              if (countEl) {
                countEl.textContent = cart.item_count;
                countEl.style.display = 'flex';
              }
            });

          setTimeout(function() {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        })
        .catch(function(error) {
          console.error('Error:', error);
          submitBtn.textContent = 'Eroare!';
          setTimeout(function() {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        });
      });
    }

    // Buy Now button - add to cart and redirect
    var buyNowBtn = document.querySelector('.buy-now-btn');
    if (buyNowBtn && productForm) {
      buyNowBtn.addEventListener('click', function(e) {
        e.preventDefault();

        var formData = new FormData(productForm);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function() {
          window.location.href = '/checkout';
        });
      });
    }

    // Initialize Fancybox for product gallery
    if (typeof Fancybox !== 'undefined') {
      Fancybox.bind('[data-fancybox="product-gallery"]', {
        // Options
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miracol-delivery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.miracol-products-swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
          480: { slidesPerView: 1 },
          600: { slidesPerView: 2 },
          800: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miracol-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var accordionBoxes = document.querySelectorAll('.accordion-box');

    accordionBoxes.forEach(function(accordionBox) {
      accordionBox.addEventListener('click', function(e) {
        var accBtn = e.target.closest('.acc-btn');
        if (!accBtn) return;

        var accordion = accBtn.closest('.accordion');
        var accContent = accordion.querySelector('.acc-content');
        var isActive = accBtn.classList.contains('active');

        // Close all other accordions in this box
        accordionBox.querySelectorAll('.accordion').forEach(function(item) {
          item.classList.remove('active-block');
          item.querySelector('.acc-btn').classList.remove('active');
          var content = item.querySelector('.acc-content');
          content.style.display = 'none';
        });

        // Toggle current accordion
        if (!isActive) {
          accordion.classList.add('active-block');
          accBtn.classList.add('active');
          accContent.style.display = 'block';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miracol-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery !== 'undefined' && jQuery.fn.owlCarousel) {
      jQuery('.main-slider-carousel').owlCarousel({
        loop: false,
        items: 1,
        autoplay: false,
        nav: false,
        dots: false
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miracol-partners"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.miracol-partners-swiper', {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        breakpoints: {
          600: { slidesPerView: 3 },
          1024: { slidesPerView: 4 }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
